import React from 'react';
import { Quote } from 'lucide-react';
import { Reveal } from './Reveal';
import { Section } from './Section';
import styles from './TestimonialsSection.module.css';

const testimonials = [
  {
    quote: 'I didn\'t expect a plant kit to change my morning. But now I spend five minutes with it before I even look at my phone. That shift alone was worth the $49.',
    author: 'Sarah M.',
    location: 'Brooklyn Heights',
  },
  {
    quote: 'There\'s something deeply satisfying about eating food you grew yourself — even in a SoHo apartment with one south-facing window. I didn\'t think that was possible for me.',
    author: 'James L.',
    location: 'SoHo, Manhattan',
  },
  {
    quote: 'I bought it as a gift for my mom. She texted me on day three with a photo of the shoots. She said it was the first time in years she\'d had a quiet morning ritual.',
    author: 'Emma K.',
    location: 'Upper West Side',
  },
];

export function TestimonialsSection() {
  return (
    <Section id="recenzie" title="What People Feel">
      <div className={styles.grid}>
        {testimonials.map((item, index) => (
          <Reveal key={item.author} delayMs={index * 110}>
            <blockquote className={styles.quote}>
              <Quote className={styles.quoteIcon} strokeWidth={1.4} aria-hidden="true" />
              <p className={styles.quoteText}>"{item.quote}"</p>
              <footer className={styles.quoteFooter}>
                <span className={styles.author}>{item.author}</span>
                <span className={styles.location}>{item.location}</span>
              </footer>
            </blockquote>
          </Reveal>
        ))}
      </div>
    </Section>
  );
}
